// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"473":"CountryFlag","554":"OnfidoForm","653":"ProjectionsChart"}[chunkId] || chunkId) + "." + {"270":"246150dfc3c6b266304e","473":"c8e2abfd56683e41e938","510":"4ca90756fb3460e305be","554":"fdde414ff002e91bc439","653":"350a8bbe8df7e6d2976e","995":"c1f4f4a12a62a4ceaeed"}[chunkId] + ".js";
};